import useIsEmea from "@dana/Common/Hooks/useIsEmea";
import { getRegionSpecificDate } from "@dana/Common/utils";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderUpload/Handlers/AddCartLineCollectionFromProducts";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}


replaceInChain(
    chain,
    PopulateApiParameter,
    props => {
        const cartLineCollection: CartLineModel[] = [];
        const today = new Date();
        props.parameter.products.forEach((product: any) => {
            const shipDate = product?.properties?.requestedShipDate;
            const isEmea = useIsEmea(props.getState());
            let requestedDate = getRegionSpecificDate(isEmea, shipDate);

            cartLineCollection.push({
                productId: product.id,
                qtyOrdered: product.qtyOrdered,
                unitOfMeasure: product.selectedUnitOfMeasure,
                properties: {
                    requestedShipDate: requestedDate,
                } as any
            } as CartLineModel);
        });

        cartLineCollection.forEach(line => {
            const parsedQty = line.qtyOrdered ? parseFloat(line.qtyOrdered.toString()) : 1;
            line.qtyOrdered = parsedQty > 0 ? parsedQty : 1;
        });

        props.apiParameter = {
            cartLineCollection: {
                cartLines: cartLineCollection,
            },
            cartId: API_URL_CURRENT_FRAGMENT,
        } as AddCartLinesApiParameter;
    },
);


